import { render, staticRenderFns } from "./switchPageOneDialog.vue?vue&type=template&id=362e46f2&"
import script from "./switchPageOneDialog.vue?vue&type=script&lang=js&"
export * from "./switchPageOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchPageOneDialog.vue?vue&type=style&index=0&id=362e46f2&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports